// Quiz module

var $ = require('jquery');
var service = require('./../QuizService');

module.exports = {
    template: require('./template.html'),
    replace: false,
    data: function () {
        return {
            formview: true,
            linkedin_connected: true
        };
    },
    computed: {

    },
    methods: {
        loginLinkedIn: function () {
            var self = this;

            IN.User.authorize(function () {
                IN.API.Profile("me")
                    .fields(["siteStandardProfileRequest"])
                    .result(function(result) {
                        service.linkedInUrl = result.values[0].siteStandardProfileRequest.url;
                        self.linkedin_connected = false;
                    });
            }, this);
        },

        sendApplication: function () {
            var self = this;

            $('#formSend').ajaxSubmit({
                data : {
                    'id': service.getId(),
                    'linkedin': service.linkedInUrl,
                },
                success: function (data) {

                    if(data.success) {
                        self.formview = false;
                        console.log(self);
                    }

                    if(!data.name) {
                        $("input[name='name']").css('border', '2px solid #E89A9A');
                    } else {
                        $("input[name='name']").css('border', '1px solid #fff');
                    }
                    if(data.city == 'none') {
                        $(".contactawrrow").css('border', '2px solid #E89A9A');
                    } else {
                       $(".contactawrrow").css('border', '1px solid #fff');
                    }
                    if(!data.phone) {
                        $("input[name='phone']").css('border', '2px solid #E89A9A');
                    } else {
                        $("input[name='phone']").css('border', '1px solid #fff');
                    }
                    if(!data.mail) {
                        $("input[name='email']").css('border', '2px solid #E89A9A');
                    } else {
                        $("input[name='email']").css('border', '1px solid #fff');
                    }
                    if(data.filename == 'fail') {
                        alert('Please upload a file or connect with Linkedin');
                    }
                    if(data.checkbox == null) {
                        $('.submitchecktext').show();
                    } else {
                        $('.submitchecktext').hide();
                    }
                    if(data.email == 'exist') {
                        alert('E-mail already exists');
                    }

                }
            });
        },

        shareSiteFbForm: function () {
            thankyou();
        },

        shareLinkedInLnForm: function () {
            shareLnThankyou();
        },

        thejobclickForm: function () {

            ga('send', 'event', 'About', 'click', 'About');

            $('.socialQuiz').toggleClass('active');
            $('.btn').toggleClass('active');
            $('.formwrap').toggleClass('active');
            $('.animateQuiz').toggleClass('active');
            $('.closeopen').toggleClass('active');
            $('.aboutWrapper').toggleClass('active');
            $('.overlay').toggleClass('active');
            $('.startText').toggleClass('active');
            $('.quiztext').toggleClass('active');
            $('.aboutskew').toggleClass('active');
            $('.badgewrapper').toggleClass('active');
            $('.wave').toggleClass('active');
            $('.socialStart').toggleClass('active');
            $('.form').toggleClass('active');
            $('.aboutInnerWrap').toggleClass('active');
        },

        tweetShareStartForm: function () {

            ga('send', 'event', 'Share', 'click', 'Twitter Thank you page');

            var loc = 'https://thejob.filtr.com';
            var title  = encodeURIComponent('I just applied for The Job by Filtr. Do you think you have what it takes? #TheJobByFiltr');
            window.open('http://twitter.com/share?url=' + loc + '&text=' + title + '&', 'twitterwindow', 'height=450, width=550, top='+($(window).height()/2 - 225) +', left='+$(window).width()/2 +', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0');
        }


    },
    ready: function () {

        $('.navbarline').css('width', '215px');

    },
    route: {

    }
}

$(document).ready(function() {
    $(window).keydown(function(event){
        if(event.keyCode == 13) {
            event.preventDefault();
            return false;
        }
    });
});
